'use client'

import type { Control } from 'react-hook-form'
import { useTranslations } from '@/lib/next-shim'

import DateInput from '@/components/ui/forms/DateInput'
import SelectInput from '@/components/ui/forms/SelectInput'
import CustomInput from '@/components/ui/forms/CustomInput'

import { CompleteProfileFormData } from '../model/completeProfileForm'

type CompleteProfileFormProps = {
  control: Control<CompleteProfileFormData>
  onSubmit: React.FormEventHandler<HTMLFormElement>
  saving: boolean
  isFrance: boolean
}

export function CompleteProfileForm({ control, onSubmit, saving, isFrance }: CompleteProfileFormProps) {
  const t = useTranslations()

  const genderOptions = [
    { value: 'M', label: t('page.CompleteProfile.genderOptions.M') },
    { value: 'F', label: t('page.CompleteProfile.genderOptions.F') },
    { value: 'O', label: t('page.CompleteProfile.genderOptions.O') },
  ]

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <DateInput id="birthday" label={t('page.CompleteProfile.birthday')} colSpan="col-span-full" control={control} required disableFuture />

      <SelectInput id="gender" label={t('page.CompleteProfile.gender')} colSpan="col-span-full" options={genderOptions} control={control} required />

      <CustomInput id="phone" label={t('page.CompleteProfile.phone')} colSpan="col-span-full" type="tel" control={control} />

      {isFrance && (
        <div>
          <CustomInput id="secu" label={t('page.CompleteProfile.secu')} colSpan="col-span-full" control={control} />
          <p className="mt-1 text-xs text-gray-500">{t('page.CompleteProfile.secuHelper')}</p>
        </div>
      )}

      <button type="submit" disabled={saving} className="ds-btn ds-btn-primary w-full text-white">
        {saving ? t('page.CompleteProfile.saving') : t('page.CompleteProfile.submit')}
      </button>
    </form>
  )
}
